"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultContext = {
    boxed: false,
    nav: [],
    search: { q: "", url: "" },
    networkRequestActive: false,
    networkAvailable: false,
    isOpen: function (id) { return false; },
    toggleMenu: function (id) { }
};
exports.NavContext = react_1.createContext(defaultContext);
